import { FC } from "react"
import classNames from "classnames"
import "./index.scss"

interface ToggleProps {
   label: string
   value: boolean
   onChange: (checked: boolean) => void
   disabled?: boolean
   className?: string
   id?: string
   testId?: string
}

const Toggle: FC<ToggleProps> = ({
   label,
   value,
   onChange,
   disabled = false,
   className,
   id,
   testId,
}) => {
   return (
      <div className={classNames("toggle-wrapper", className)}>
         <div
            className={classNames("toggle", {
               ["toggle--active"]: value,
               ["toggle--disabled"]: disabled,
            })}
            {...(!disabled && { onClick: () => onChange(!value) })}
            role="switch"
            aria-checked={value}
            aria-disabled={disabled}
            aria-label={label}
            id={id}
            data-testid={testId}
         >
            <div className="toggle__slider" />
         </div>
         <label
            htmlFor={id}
            className="toggle__label"
         >
            {label}
         </label>
      </div>
   )
}

export default Toggle
